import { FACE_ORDER } from './cube-config.js';

export const APP_VERSION = '1.2.2';
export const STATE_TRANSFER_SCHEMA_VERSION = 1;
export const COLOR_NUMBERING = Object.freeze({
  white: 0,
  red: 1,
  green: 2,
  yellow: 3,
  orange: 4,
  blue: 5,
});

export function parseTransferData(serialized) {
  try {
    return typeof serialized === 'string' ? JSON.parse(serialized) : serialized;
  } catch (cause) {
    throw new TypeError(`JSON 解析失败：${cause.message}`);
  }
}

export function assertPlainObject(value, label) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw new TypeError(`${label}必须是对象`);
}

export function assertArray(value, length, label) {
  if (!Array.isArray(value) || value.length !== length) throw new TypeError(`${label}必须包含 ${length} 项`);
}

export function sameArray(left, right) {
  return left.length === right.length && left.every((value, index) => value === right[index]);
}

export function cloneStickers(stickers) {
  return Object.fromEntries(FACE_ORDER.map((face) => [face, [...stickers[face]]]));
}

export function faceMatrices(facelets, order) {
  const perFace = order * order;
  return Object.fromEntries(FACE_ORDER.map((face, faceIndex) => {
    const values = facelets.slice(faceIndex * perFace, faceIndex * perFace + perFace);
    return [face, Array.from({ length: order }, (_, row) => values.slice(row * order, row * order + order))];
  }));
}

export function validateMatrices(matrices, expected, order) {
  assertPlainObject(matrices, 'urfdlbMatrices');
  const flattened = [];
  for (const face of FACE_ORDER) {
    assertArray(matrices[face], order, `urfdlbMatrices.${face}`);
    for (let row = 0; row < order; row += 1) {
      assertArray(matrices[face][row], order, `urfdlbMatrices.${face}[${row}]`);
      flattened.push(...matrices[face][row]);
    }
  }
  if (!sameArray(flattened, expected)) throw new TypeError('URFDLB 六面矩阵与 normalizedFacelets 不一致');
}

export function validateColorNumbering(numbering) {
  assertPlainObject(numbering, 'colorNumbering');
  for (const [color, number] of Object.entries(COLOR_NUMBERING)) {
    if (numbering[color] !== number) throw new TypeError(`colorNumbering.${color} 必须为 ${number}`);
  }
}

export function assertModernMetadata(data) {
  if (data.schemaVersion !== STATE_TRANSFER_SCHEMA_VERSION) {
    throw new TypeError(`不支持的 schemaVersion：${data.schemaVersion ?? '缺失'}`);
  }
  if (typeof data.appVersion !== 'string' || !data.appVersion.trim()) throw new TypeError('appVersion 必须是非空字符串');
  if (typeof data.exportedAt !== 'string' || Number.isNaN(Date.parse(data.exportedAt))) {
    throw new TypeError('exportedAt 必须是有效的 ISO 日期时间');
  }
}
